import { observable, ObservableMap } from 'mobx'
import { observer } from 'mobx-react'
import * as React from 'react'
import styled from 'styled-components'
import { Button } from '../../atoms/Button'
import { Checkbox } from '../../atoms/Checkbox'
import { FieldNo } from '../../atoms/FieldNo'
import { HideTablet } from '../../atoms/HideTablet'
import { IntakeStepCol } from '../../atoms/IntakeStepCol'
import { IntakeStepContainer } from '../../atoms/IntakeStepContainer'
import { IntakeStepNoColTablet } from '../../atoms/IntakeStepNoColTablet'
import { Label } from '../../atoms/Label'
import {
  GetOwnIntakeQuery_getOwnIntake, UpdateOwnIntakeMutationVariables,
} from '../../schema/schemaTypes'

interface IProps {
  id: string
  active: boolean
  activeValue: ObservableMap<string, boolean>
  description?: string,
  onChange: (value: any) => void
  handleSubmit: (vars: UpdateOwnIntakeMutationVariables) => void
  intake: GetOwnIntakeQuery_getOwnIntake
  isCompleted: boolean
  label: string
  no: number
  options?: Array<{ name: string, label: string }>
}

@observer
export class IntakeStepChecklist extends React.Component<IProps> {
  @observable private values = new ObservableMap<string, boolean>()

  public componentWillMount() {
    for (const option of this.props.options || []) {
      this.values.set(option.name, this.props.intake[option.name] || false)
    }
    if (this.props.active && this.props.activeValue) {
      this.values.merge(this.props.activeValue)
    }
  }

  public render () {
    const { active, description, id, isCompleted, label, no, options } = this.props

    // @ts-ignore
    window.handleStepSubmit = this.handleSubmit

    return (
      <IntakeStepContainer id={id} active={active}>
        <IntakeStepNoColTablet>
          <FieldNo checked={isCompleted}>{no}</FieldNo>
        </IntakeStepNoColTablet>
        <IntakeStepCol>
          <Label><HideTablet><FieldNo checked={isCompleted}>{no}</FieldNo></HideTablet>{label}</Label>
          <Description>{description}</Description>
          {(options || []).map(o => (
            <Checkbox
              disabled={!active} onChange={this.toggleValue}
              id={`intake-${id}-options-${o.name}`} name={o.name} label={o.label}
              checked={this.values.get(o.name)} key={o.name}
            />
          ))}
          <Button style={{ marginTop: 15 }} onClick={this.handleSubmit}>{process.env.REACT_APP_LANGUAGE === 'es' ? 'PROXIMO': 'NEXT'}</Button>
        </IntakeStepCol>
      </IntakeStepContainer>
    )
  }

  private toggleValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.currentTarget.name
    this.values.set(name, !this.values.get(name))
    this.props.onChange(this.values)
  }

  private handleSubmit = () => {
    console.log('values', this.values.toJSON())
    this.props.handleSubmit(this.values.toJSON())
  }
}

const Description = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  white-space: pre-line;
`



// WEBPACK FOOTER //
// ./src/organisms/Intakes/IntakeStepChecklist.tsx